import CustomerSupportLink from './CustomerSupportLink';

export default CustomerSupportLink;
